export enum DocumentTypeKey {
  ASSET = 'asset',
  BANKING = 'banking',
  ESTATE = 'estate',
  IDENTIFICATION = 'identification',
  LIABILITY = 'liability',
  TAX = 'tax',
  OTHERS = 'others',
  BILLING = 'billing',
  INTERNAL_DOCUMENT = 'internal_document',
  ESIGN_ENVELOPE = 'esign_envelope',
  COLLABORATORS = 'collaborators',
  AFTERCARE_INSTRUCTIONS_AND_FORMS = 'aftercare_instructions_and_forms'
}
